import React, { FC, ReactElement } from 'react';
import { Alert } from 'react-bootstrap';
import { localizeType } from '../../commonType';
import { getADATitle } from '../../util/Ada';
import withLocalization from '../hoc/withLocalization';

interface NoAvailabilityInformationType {
  hasNoAvailability: boolean;
  preferences: string[];
  localize: localizeType;
}
const NoAvailabilityInformation: FC<NoAvailabilityInformationType> = (
  props: NoAvailabilityInformationType,
): ReactElement => {
  const { hasNoAvailability, preferences, localize } = props;
  const preferencesText =
    hasNoAvailability && preferences && preferences.length > 0
      ? preferences.map((e) => localize(getADATitle(e))).join(', ')
      : undefined;
  const displayText =
    preferencesText !== undefined
      ? localize(
          'preview-sales-engine.static-content.copy.Labels.labels#preview-sales-engine.static-content.copy.no-availibility-text',
          preferencesText,
        )
      : localize('preview-sales-engine.static-content.copy.Labels.labels#avalibility-text');
  return <>{hasNoAvailability ? <Alert variant="warning">{displayText}</Alert> : <></>}</>;
};

export default React.memo(withLocalization(NoAvailabilityInformation));
